module.exports = __webpack_public_path__ + "static/media/menu-icon.0682799f.svg";